/* Beyond Tanned - Sunset Pop: Shoot gallery.
   Vanilla JS, scoped per section instance (a page can carry more than one
   instance of this section). Re-initialises on Shopify theme-editor section
   reloads via the shopify:section:load event. */
(function () {
  'use strict';

  function mmss(totalSeconds) {
    var s = Math.max(0, Math.floor(totalSeconds || 0));
    var m = Math.floor(s / 60);
    var r = s % 60;
    return m + ':' + (r < 10 ? '0' : '') + r;
  }

  function init(root) {
    if (!root || root.dataset.btgInited) return;
    root.dataset.btgInited = 'true';

    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-btg-tile]'));
    if (!tiles.length) return;

    var hoverPreview = root.dataset.btgHoverPreview !== 'false';
    var lightbox = root.querySelector('[data-btg-lightbox]');
    var stage = lightbox.querySelector('[data-btg-stage]');
    var counterEl = lightbox.querySelector('[data-btg-counter]');
    var shootEl = lightbox.querySelector('[data-btg-lb-shoot]');
    var yearEl = lightbox.querySelector('[data-btg-lb-year]');
    var closeBtn = lightbox.querySelector('[data-btg-close]');
    var prevBtn = lightbox.querySelector('[data-btg-prev]');
    var nextBtn = lightbox.querySelector('[data-btg-next]');
    var infoPanel = lightbox.querySelector('[data-btg-info]');
    var titleEl = lightbox.querySelector('[data-btg-lb-title]');
    var specEl = lightbox.querySelector('[data-btg-lb-spec]');
    var creditEl = lightbox.querySelector('[data-btg-lb-credit]');
    var altPanel = lightbox.querySelector('[data-btg-alt-panel]');
    var altTextEl = lightbox.querySelector('[data-btg-alt-text]');
    var transcriptBtn = lightbox.querySelector('[data-btg-transcript-btn]');
    var transcriptEl = lightbox.querySelector('[data-btg-transcript]');
    var videoChrome = lightbox.querySelector('[data-btg-video-chrome]');
    var playBtn = lightbox.querySelector('[data-btg-play]');
    var timeEl = lightbox.querySelector('[data-btg-time]');
    var durEl = lightbox.querySelector('[data-btg-dur]');
    var scrub = lightbox.querySelector('[data-btg-scrub]');
    var scrubFill = lightbox.querySelector('[data-btg-scrub-fill]');
    var scrubHandle = lightbox.querySelector('[data-btg-scrub-handle]');
    var muteBtn = lightbox.querySelector('[data-btg-mute]');

    var current = -1;
    var lastFocused = null;
    var activeVideo = null;
    var homeParent = null;
    var homeNext = null;
    var transcriptOpen = false;
    var scrubbing = false;

    function tileData(tile) {
      return {
        type: tile.dataset.btgType,
        title: tile.dataset.btgTitle || '',
        shoot: tile.dataset.btgShoot || '',
        year: tile.dataset.btgYear || '',
        spec: tile.dataset.btgSpec || '',
        credit: tile.dataset.btgCredit || '',
        alt: tile.dataset.btgAlt || '',
        transcript: tile.dataset.btgTranscript || '',
        fullSrc: tile.dataset.btgFullSrc || ''
      };
    }

    function releaseActiveVideo() {
      if (!activeVideo) return;
      activeVideo.pause();
      activeVideo.muted = true;
      activeVideo.controls = false;
      activeVideo.loop = true;
      activeVideo.classList.add('bt-sp-gallery__preview');
      activeVideo.classList.remove('is-active');
      if (homeParent) {
        homeParent.insertBefore(activeVideo, homeNext);
      }
      activeVideo = null;
      homeParent = null;
      homeNext = null;
    }

    function updateScrub() {
      if (!activeVideo || !activeVideo.duration) return;
      var pct = Math.min(100, (activeVideo.currentTime / activeVideo.duration) * 100);
      scrubFill.style.width = pct + '%';
      scrubHandle.style.left = pct + '%';
      timeEl.textContent = mmss(activeVideo.currentTime) + ' / ' + mmss(activeVideo.duration);
    }

    function setPlayIcon() {
      if (!activeVideo) return;
      playBtn.textContent = activeVideo.paused ? '▶' : '❬❬';
    }

    function render() {
      var tile = tiles[current];
      var data = tileData(tile);
      var n = tiles.length;

      counterEl.textContent = String(current + 1).padStart(2, '0') + ' / ' + String(n).padStart(2, '0');
      shootEl.textContent = data.shoot;
      yearEl.textContent = data.year;
      lightbox.setAttribute('aria-label', data.title + ' — ' + data.shoot + ' ' + data.year);

      stage.innerHTML = '';
      releaseActiveVideo();

      var isVideo = data.type === 'video';
      var video = isVideo ? tile.querySelector('[data-btg-video]') : null;

      if (isVideo && video) {
        homeParent = video.parentNode;
        homeNext = video.nextSibling;
        video.classList.remove('bt-sp-gallery__preview');
        video.classList.add('is-active');
        video.muted = false;
        video.loop = false;
        video.controls = false;
        video.currentTime = 0;
        video.setAttribute('playsinline', '');
        stage.appendChild(video);
        activeVideo = video;
        video.play().catch(function () {});
        videoChrome.hidden = false;
        var badgeText = (tile.querySelector('[data-btg-dur-badge]') || {}).textContent || '';
        durEl.textContent = video.duration ? mmss(video.duration) : badgeText;
        updateScrub();
        setPlayIcon();
      } else if (!isVideo && data.fullSrc) {
        var img = document.createElement('img');
        img.src = data.fullSrc;
        img.alt = data.alt;
        stage.appendChild(img);
        videoChrome.hidden = true;
      } else {
        var empty = document.createElement('div');
        empty.className = 'bt-sp-gallery__lb-empty';
        var kind = document.createElement('span');
        kind.className = 'bt-sp-gallery__lb-empty-kind';
        kind.textContent = (isVideo ? 'Film' : 'Still') + ' · ' + data.spec;
        var note = document.createElement('span');
        note.className = 'bt-sp-gallery__lb-empty-note';
        note.textContent = isVideo
          ? 'No video file has been added to this tile yet.'
          : 'No image has been added to this tile yet.';
        empty.appendChild(kind);
        empty.appendChild(note);
        stage.appendChild(empty);
        videoChrome.hidden = true;
      }

      if (infoPanel) {
        titleEl.textContent = data.title;
        specEl.textContent = data.spec;
        creditEl.textContent = data.credit;
        if (altPanel) {
          altTextEl.textContent = data.alt;
          if (transcriptBtn) {
            transcriptBtn.hidden = !(isVideo && data.transcript);
          }
          transcriptOpen = false;
          if (transcriptEl) {
            transcriptEl.hidden = true;
            transcriptEl.textContent = data.transcript;
          }
          if (transcriptBtn) transcriptBtn.textContent = 'Read transcript';
        }
      }
    }

    function lockScroll(lock) {
      document.documentElement.style.overflow = lock ? 'hidden' : '';
    }

    function openAt(index) {
      var n = tiles.length;
      current = ((index % n) + n) % n;
      lastFocused = document.activeElement;
      render();
      lightbox.hidden = false;
      lockScroll(true);
      closeBtn.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      lightbox.hidden = true;
      releaseActiveVideo();
      lockScroll(false);
      document.removeEventListener('keydown', onKeydown);
      current = -1;
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function step(delta) {
      openAt(current + delta);
    }

    function onKeydown(e) {
      if (current < 0) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      else if (e.key === ' ' && activeVideo) {
        e.preventDefault();
        if (activeVideo.paused) activeVideo.play().catch(function () {}); else activeVideo.pause();
      }
    }

    tiles.forEach(function (tile, i) {
      var hit = tile.querySelector('[data-btg-open]');
      if (hit) hit.addEventListener('click', function () { openAt(i); });

      var video = tile.querySelector('[data-btg-video]');
      var img = tile.querySelector('img');

      function markLoaded() { tile.classList.add('is-loaded'); }
      if (img) {
        if (img.complete && img.naturalWidth) markLoaded();
        else img.addEventListener('load', markLoaded, { once: true });
      } else {
        markLoaded();
      }

      if (video) {
        video.addEventListener('loadedmetadata', function () {
          var badge = tile.querySelector('[data-btg-dur-badge]');
          if (badge && !badge.textContent.trim()) badge.textContent = mmss(video.duration);
        });

        if (hoverPreview) {
          var enter = function () {
            if (activeVideo === video) return;
            video.classList.add('is-active');
            video.currentTime = 0;
            video.play().catch(function () {});
          };
          var leave = function () {
            if (activeVideo === video) return;
            video.pause();
            video.classList.remove('is-active');
          };
          tile.addEventListener('pointerenter', function (e) {
            if (e.pointerType === 'touch') return;
            enter();
          });
          tile.addEventListener('pointerleave', function (e) {
            if (e.pointerType === 'touch') return;
            leave();
          });
          if (hit) {
            hit.addEventListener('focus', enter);
            hit.addEventListener('blur', leave);
          }
        }
      }
    });

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function () { step(-1); });
    nextBtn.addEventListener('click', function () { step(1); });

    playBtn.addEventListener('click', function () {
      if (!activeVideo) return;
      if (activeVideo.paused) activeVideo.play().catch(function () {}); else activeVideo.pause();
    });
    lightbox.addEventListener('play', function (e) { if (e.target === activeVideo) setPlayIcon(); }, true);
    lightbox.addEventListener('pause', function (e) { if (e.target === activeVideo) setPlayIcon(); }, true);
    lightbox.addEventListener('timeupdate', function (e) { if (e.target === activeVideo && !scrubbing) updateScrub(); }, true);
    lightbox.addEventListener('loadedmetadata', function (e) {
      if (e.target !== activeVideo) return;
      durEl.textContent = mmss(activeVideo.duration);
      updateScrub();
    }, true);

    muteBtn.addEventListener('click', function () {
      if (!activeVideo) return;
      activeVideo.muted = !activeVideo.muted;
      muteBtn.textContent = activeVideo.muted ? 'Unmute' : 'Mute';
    });

    function seekFromEvent(e) {
      if (!activeVideo || !activeVideo.duration) return;
      var rect = scrub.getBoundingClientRect();
      var x = ('touches' in e && e.touches[0]) ? e.touches[0].clientX : e.clientX;
      var pct = Math.max(0, Math.min(1, (x - rect.left) / rect.width));
      activeVideo.currentTime = pct * activeVideo.duration;
      updateScrub();
    }
    scrub.addEventListener('pointerdown', function (e) { scrubbing = true; seekFromEvent(e); });
    window.addEventListener('pointermove', function (e) { if (scrubbing) seekFromEvent(e); });
    window.addEventListener('pointerup', function () { scrubbing = false; });
    scrub.addEventListener('click', seekFromEvent);

    if (transcriptBtn) {
      transcriptBtn.addEventListener('click', function () {
        transcriptOpen = !transcriptOpen;
        transcriptEl.hidden = !transcriptOpen;
        transcriptBtn.textContent = transcriptOpen ? 'Hide transcript' : 'Read transcript';
      });
    }

    var swipeStartX = null;
    stage.addEventListener('pointerdown', function (e) { swipeStartX = e.clientX; });
    stage.addEventListener('pointerup', function (e) {
      if (swipeStartX == null) return;
      var dx = e.clientX - swipeStartX;
      swipeStartX = null;
      if (Math.abs(dx) > 60) step(dx < 0 ? 1 : -1);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-btg-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-btg-root]');
    if (root) init(root);
  });
})();
